import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/styles/shared-styles.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__